export const basePrefix = "/~/sj/";

export let isIsolated = import.meta.env.VITE_ISOLATION_ORIGIN !== "none";
